import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";

const deriveInitials = (name, email) => {
  if (name) {
    const parts = name.trim().split(" ").filter(Boolean);
    if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
    return `${parts[0][0] ?? ""}${parts[1][0] ?? ""}`.toUpperCase();
  }
  if (email) {
    const [local] = email.split("@");
    return local.slice(0, 2).toUpperCase();
  }
  return "NA";
};

const loggingSlice = createSlice({
  name: "logging",
  initialState: [],
  reducers: {
    addLog: (state, action) => {
      state.push(action.payload);
    },
  },
});

export const { addLog } = loggingSlice.actions;

export const logAction = (actionType, details) => async (dispatch, getState) => {
  const user = getState().user.userInfo;
  const initials = user?.initials || deriveInitials(user?.name, user?.email);

  if (!actionType || !user) return;

  const logEntry = {
    initials,
    actionType,
    details,
    timestamp: new Date().toISOString(),
  };

  try {
    await axios.post("/api/logs", logEntry);
    dispatch(addLog(logEntry));
  } catch (error) {
    // Avoid interrupting user flow if logging fails
    console.error("Failed to persist log entry", error);
  }
};

export default loggingSlice.reducer;
